// src/pages/Support/SupportProfile.tsx
import React from 'react';
import { ChangePassword } from '../../components/profile/ChangePassword';
import { useAuth } from '../../hooks/useAuth';

const SupportProfile: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Support Profile</h1>
      <div className="bg-white rounded-2xl p-6 shadow-lg mb-6">
        <h2 className="text-xl font-semibold mb-4">Account Information</h2>
        <p><strong>Name:</strong> {user?.fullName}</p>
        <p><strong>Email:</strong> {user?.email}</p>
        <p><strong>Role:</strong> {user?.role}</p>
      </div>
      <div className="bg-white rounded-2xl p-6 shadow-lg">
        <ChangePassword />
      </div>
    </div>
  );
};

export default SupportProfile;